import styled from 'styled-components';
import TriangleSvg from './svg/triangle.svg';

interface ContentWrapperProps{
  isColumn?:boolean;
}
export const Container = styled.div`
  gap: 60px;
  width: 100%;
  height: 200px;

  display: flex;
  position: relative;
  
  grid-area: description;
  margin: -12.3rem 0 0 0;

  svg {
    transform: scale(.9);
    margin-left: -5rem;
  }
  /* background: ${({ theme }) => theme.colors.background}; */
  @media(max-width: 820px) {
    margin: -3.8rem 0 0 0;
  }
`;

export const TriangleIcon = styled(TriangleSvg)`
  width: 100%;
  height: 100%;
  position: absolute;
`;

export const ContentWrapper = styled.div<ContentWrapperProps>`
  width: 80%;
  display: flex;
  margin: 0 auto;
  flex-direction: column;

  h1 {
    margin: 3rem 0 1rem 0;
    font-size: 38px;
    color: ${({ theme }) => theme.colors.button}
  }
  
  section {
    column-count: ${props => props.isColumn ? 2:1};
    column-width: 50%;
    p {
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
    }

    p:nth-child(1) {
      margin-bottom:11.1rem;
      margin-right:3.1rem;
    }
  }

  @media(max-width: 820px) {
    width: 100%;
    padding: 24px;
      h1{
        font-size: 38px;
      }
    section {
    column-count: 1;
    column-width: 100%;
   
    p:nth-child(1) {
      margin-bottom: 1rem;
      
    }

    p:nth-child(2) {
      margin-bottom: 5rem;
    }
  }
  }
`;

